import { DeviceProfile } from "./DeviceProfile";

export type LayoutMode =
  | "compact"
  | "comfortable"
  | "desktop";

export function resolveLayoutMode(
  device: DeviceProfile
): LayoutMode {

  if (device.isDesktop) {
    return "desktop";
  }

  if (device.width <= 430 || device.compactHeight) {
    return "compact";
  }

  return "comfortable";
}
